import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { resourceActions, resourcesActions } from './resources.actions';
import { ResourceDto, resourceInit } from './resources.dtos';

const resourceReducer = combineReducers({
    list: createReducer<ResourceDto[]>([] as ResourceDto[])
      .handleAction(
        [
          resourcesActions.success,
        ], (state, action) => action.payload),
  
    resource: createReducer<ResourceDto>(resourceInit)
      .handleAction(
        [
          resourceActions.success,
        ], (state, action) => action.payload),
  
  });
  
  
  export default resourceReducer;